module.exports = __webpack_public_path__ + "static/media/tatsiana.984a4de3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Testimonial/tatsiana.jpg
// module id = 92
// module chunks = 0